"use strict";
exports.__esModule = true;
exports.CONFIRM_CARD = void 0;
exports.CONFIRM_CARD = {
    HEADER: 'Confirm your card',
    BODY: 'Is this still the card you want to use for your payments to Flex?',
    AUTHORIZATION: "By clicking confirm card, I verify that I am an authorized user of this card.",
    CHANGE_CARD: 'Change card',
    CTA: 'Confirm card'
};
